export default __webpack_public_path__ + "static/media/020-microscope.24bb70aa.svg";